module.exports = __webpack_public_path__ + "img/special-class.dc58273f.jpeg";